import React, { useEffect, useState } from "react";
import axios from "axios";
import configData from "../config.json";
import { useParams } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  Cell,
  ComposedChart,
} from "recharts";

const SalesAnalysis = ({ misData, branchName, fYear }) => {

  const [chartType, setChartType] = useState("line");

  const maxValue = Math.max(
    ...misData.map(item =>
    Math.max(Number(item.mtQty) || 0, Number(item.salesQty) || 0, Number(item.preSalesQty) || 0) )
  );

  // =========================
  // FORMAT FUNCTIONS
  // =========================
  const format = (value) => {
    if (value === null || value === undefined || isNaN(value)) {
      return "0.00";
    }

    return Number(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const growthPercent = (current, previous) => {
    if (!previous || previous === 0) return 0;

    return (((current - previous) / previous) * 100).toFixed(2);
  };

  const achievementPercent = (actual, target) => {
    if (!target || target === 0) return 0;

    return ((actual / target) * 100).toFixed(2);
  };

  const printDiv_sales = (printDiv) => {
        const printElement = document.getElementById(printDiv);

        if (!printElement) {
            console.error("Print div not found");
            return;
        }

        const printWindow = window.open("", "_blank", "width=900,height=650");

        printWindow.document.write(`
            <html>
                <head>
                <title>Print</title>
                <!-- Bootstrap CSS (optional) -->
                <link rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
                <style>
                    body{ padding:20px; font-family: Arial, sans-serif;}
                    @media print { body{ margin:0; }}
                </style>
                </head>
                <body>
                    ${printElement.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
  };

  return(
    <>
      <div className="card shadow mb-4" id="printDiv_sales">

        <div className="card-header bg-primary text-white d-flex justify-content-between">

          <h5>
            Sales Comparison Analysis
          </h5>

          <div>
            <button className="btn btn-sm btn-warning me-2" onClick={() => setChartType("bar")} > <Icon.BarChartLineFill /> </button>

            <button className="btn btn-sm btn-info me-2" onClick={() => setChartType("line")} > <Icon.GraphUpArrow /> </button>

            <button className="btn btn-sm btn-info" onClick={() => printDiv_sales("printDiv_sales")}> <Icon.PrinterFill /></button>

          </div>
        </div>

        <div className="card-body">

          <div className="table-responsive fixed-table-container text-white clearfix small z-1">
                  <table class="table table-bordered table-hover align-middle text-center shadow-sm mis-table" style={{fontSize:'13px'}}>
                    <thead class="table-primary">
                      <tr class="table-info">
                        <th rowspan="2">Month Name</th>

                        <th colspan="4">Sales Target</th>
                        
                
                        <th colspan="8">Financial Year {fYear}-{Number(fYear)+1}</th>
                        <th colspan="4" style={{backgroundColor:'pink'}}>Previous Year</th>

                      </tr>
                      <tr >
                        <th rowspan="2">Yearly Target<hr></hr>Value</th>
                        <th rowspan="2">Monthly Target<hr></hr>Value</th>
                        <th rowspan="2">Cum. Target<hr></hr>Value</th>
                        <th rowspan="2">Unit<hr></hr>Amount</th>

                        <th >Opening Stock</th>
                        <th >Pro. Qty<hr></hr>Value</th>
                        <th >Cum. Pro. Qty<hr></hr>Value</th>
                        <th >Sales. Qty<hr></hr>Value</th>
                        <th >Cum. Qty<hr></hr>Value</th>
                        <th >Closing Stock</th>
                        <th>Sales Achiv.</th>
                        <th>Cum. Achiv.</th>

                        <th >Sales. Qty<hr></hr>Value</th>
                        <th >Cum. Qty<hr></hr>Value</th>
                        <th>Sales Achi.</th>
                        <th>Cum. Achi.</th>

                      </tr>
                    </thead>
                    <tbody>
                    {
                    misData && misData.length>0 && misData.map((data)=>
                    <tr>
                      <td>{data.monthName}</td>
        
                      <td>{Number(data.targetQty).toFixed(2).toLocaleString('en-IN')}<hr></hr>{Number(data.targetValue).toFixed(2).toLocaleString('en-IN')}</td>
                      <td>{Number(data.mtQty)}<hr></hr>{data.mtValue!== null ? Number(data.mtValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                      <td>{data.cumMtQty!== null ? Number(data.cumMtQty).toFixed(2).toLocaleString('en-IN'):'0.00'}<hr></hr>{data.cumMtValue!== null ? Number(data.cumMtValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
        
                      <td>{data.units}<hr></hr>Lac</td>
        
                      <td>{Number(data.openingQty).toFixed(2).toLocaleString('en-IN')}</td>

                      <td>{data.proQty!== null ? data.proQty:'0.00'}<hr></hr>{data.proValue!== null ? Number(data.proValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                      <td>{Number(data.cumProQty)}<hr></hr>{data.cumProValue!== null ? Number(data.cumProValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                      <td>{Number(data.salesQty)}<hr></hr>{data.salesValue!== null ? Number(data.salesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                      <td>{Number(data.cumSalesQty)}<hr></hr>{data.cumSalesValue!== null ? Number(data.cumSalesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                      <td>{Number(data.closingQty).toFixed(2).toLocaleString('en-IN')}</td>
                      <td style={(data.salesQty/data.mtQty)*100<10 ? {color:'red',fontWeight:'bold'}:(data.salesQty/data.mtQty)*100<30 ? {color:'blue',fontWeight:'bold'}:{color:'green',fontWeight:'bold'}} >
                          {data.salesQty>0 ? ((data.salesQty/data.mtQty)*100).toFixed(2):'0'} % 
                      </td>
                      <td>{data.cumSalesQty>0 ? Number((data.cumSalesQty/data.cumMtQty)*100).toFixed(2).toLocaleString('en-IN'):'0'} %</td>


                      <td>{data.preSalesQty!== null ? Number(data.preSalesQty):'0.00'}<hr></hr>{data.preSalesValue!== null ? Number(data.preSalesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                      <td>{Number(data.cumPreSalesQty)}<hr></hr>{data.cumPreSalesQty!== null ? Number(data.cumPreSalesValue).toFixed(2).toLocaleString('en-IN'):'0.00'}</td>
                      <td>{(data.preTargetQty>0 && data.preSalesQty>0) ? Number((data.preSalesQty/(data.preTargetQty/12))*100).toFixed(2):'0'} % </td>
                      <td>{(data.preTargetQty>0 && data.cumPreSalesQty>0) ? Number((data.cumPreSalesQty/((data.preTargetQty/12)*data.fMonth))*100).toFixed(2):'0'} % </td>
                    </tr>
                    )}
                    </tbody>
                  </table>
          </div>

          {/* =========================================
                      CHART SECTION
          ========================================= */}

          <div style={{ width: "100%", height: 450 }}>

            <ResponsiveContainer>

              {chartType === "bar" ? (

                <BarChart data={misData} margin={{ top: 20, right: 30, left: 20, bottom: 50,}}>
                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="monthName" angle={-30} textAnchor="end"/>
                  <YAxis domain={[0, Math.ceil(maxValue * 1.2)]}/>
                  <Tooltip />
                  <Legend />

                  <Bar dataKey="mtQty" fill="#6f42c1" name="Target">
                    <LabelList dataKey="mtQty" position="top" fill="black" />
                  </Bar>

                  <Bar dataKey="salesQty" fill="#198754" name="Current Sales" >
                    <LabelList dataKey="salesQty" position="top"/>
                  </Bar>

                  <Bar dataKey="preSalesQty" fill="#fd7e14" name="Previous Sales" >
                    <LabelList dataKey="preSalesQty" position="top"/>
                  </Bar>
                </BarChart>

              ) : (

                <ComposedChart data={misData} margin={{ top: 20, right: 30, left: 20, bottom: 50,}}>
                  <CartesianGrid strokeDasharray="3 3" />

                  <XAxis dataKey="monthName" angle={-30} textAnchor="end"/>
                  <YAxis domain={[0, Math.ceil(maxValue * 1.2)]}/>
                  <Tooltip />
                  <Legend />

                  {/* <Bar dataKey="proQty" fill="#198754"  name="Current Production"/> */}
                  <Line type="monotone" dataKey="salesQty" stroke="#198754" strokeWidth={3} name="Current Sales"
                    label={{ position: "insideRight" }}
                  />

                  <Line type="monotone" dataKey="preSalesQty" stroke="#fd7e14" strokeWidth={3} name="Previous Sales"
                    label={{ position: "insideRight" }}
                  />

                  <Line type="monotone" dataKey="mtQty" stroke="#6f42c1" strokeWidth={3} name="Target"
                    label={{ position: "insideRight" }}
                  />
                </ComposedChart>

              )}
            </ResponsiveContainer>
          </div>
        </div>
      </div>

    </>
  )

}

export default SalesAnalysis;